import eventBus from '@sas/nova-core/eventBus';
import { useEffect } from 'react';

export type SettingsChangeEventInfo = Array<{
  key: string;
  value: string | undefined;
  oldValue: string | undefined;
}>;

// Used as EventData for the eventBus
export type SettingsChangeEvent = {
  data: SettingsChangeEventInfo;
  appId?: string;
};

enum SettingsEventTypes {
  Change = 'SettingsEvent.Change',
}

export interface SettingsChangeListener {
  (name: string, data?: { data?: SettingsChangeEvent }): void;
}

export function useSubscribeForSettingsChange(changeListener: SettingsChangeListener) {
  useEffect(() => {
    subscribeSettingsChange(changeListener);
    return () => {
      unSubscribeSettingsChange(changeListener);
    };
  }, [changeListener]);
}

export function subscribeSettingsChange(listener: SettingsChangeListener) {
  eventBus.subscribe(SettingsEventTypes.Change, listener);
}

export function unSubscribeSettingsChange(listener: SettingsChangeListener) {
  eventBus.unsubscribe(SettingsEventTypes.Change, listener);
}

export function fireSettingsChange(eventInfo: SettingsChangeEventInfo, appId?: string) {
  eventBus.publish(SettingsEventTypes.Change, {
    data: { data: eventInfo, appId },
  });
}
